import type * as React from 'react';
import { getPaginated } from '@Domain/Api';
import facilitiesFetched, {
	type FacilitiesFetchedAction,
	type FacilityPayload,
} from '@Application/Facilities/Facilities/Actions/facilitiesFetched';
import facilitiesFetchFailed, {
	type FacilitiesFetchFailedAction,
} from '@Application/Facilities/Facilities/Actions/facilitiesFetchFailed';
import type FetchFacilities from '@Application/Facilities/Facilities/Queries/FetchFacilities';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilitiesFetchedAction | FacilitiesFetchFailedAction;

type PaginatedFacilities = {
	totalRecords: number;
	results: FacilityPayload[];
};

export default (query: FetchFacilities) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Page indexing starts at 0 server-side, and `getPaginated` only walks every page when called
			// with `page: 0` — its internal guard only catches `page > 1`.
			const response = await getPaginated<PaginatedFacilities>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/facilities`,
				{ page: 0, rowsPerPage: 100 },
			);

			const action = facilitiesFetched(response.results, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilitiesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
